import { render } from "./Agreement.vue?vue&type=template&id=65c1d248&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=65c1d248&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65c1d248"

export default script